var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-particles',{staticClass:"vue-particles",attrs:{"color":"#dedede","particleOpacity":0.7,"particlesNumber":120,"shapeType":"circle","particleSize":3,"linesColor":"#dedede","linesWidth":1,"lineLinked":true,"lineOpacity":0.8,"linesDistance":150,"moveSpeed":5,"hoverEffect":true,"hoverMode":"grab","clickEffect":false,"clickMode":"push"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5891930","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Particles.vue
// module id = null
// module chunks = 